import { decode } from 'base64-arraybuffer'

import { base64UrlToBase64 } from '@cash-web/shared/util-encoding'

export function decodeOptions(options?: string) {
  const jsonOptions = options ? JSON.parse(options) : {}

  const decodedChallenge = decode(base64UrlToBase64(jsonOptions.challenge))
  const decodedAllowCredentials =
    jsonOptions.allowCredentials?.map((cred: { id: string }) => {
      return { ...cred, id: decode(base64UrlToBase64(cred.id)) }
    }) || []

  const decodedOptions = {
    ...jsonOptions,
    challenge: decodedChallenge,
    allowCredentials: decodedAllowCredentials,
  }

  return decodedOptions
}
